import { render, staticRenderFns } from "./Industry.vue?vue&type=template&id=46e191e2&scoped=true&"
import script from "./Industry.vue?vue&type=script&lang=js&"
export * from "./Industry.vue?vue&type=script&lang=js&"
import style0 from "./Industry.vue?vue&type=style&index=0&id=46e191e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e191e2",
  null
  
)

export default component.exports